import ScreeningAlertList from './ScreeningAlertList';

export default { ScreeningAlertList };
